export enum ROLES {
  ADMIN = 'ADMIN',
  USER = 'USER',
  DISTRI = 'DISTRI',
  FARMER = 'FARMER',
  INDUSTRIAL = 'INDUSTRIAL',
  SAMPLER = 'SAMPLER',
}
